import React, { Component } from 'react'
import Cursor from './cursor'

import { isMobile } from '../../../utils'
import './style.scss'

export default class BgAnime extends Component {
  ref: HTMLDivElement | null = null
  cursor: Cursor | null = null

  componentDidMount(): void {
    if (this.ref) {
      this.cursor = new Cursor({
        // common
        container: this.ref,
        initialPosition: {
          x: window.innerWidth / 2,
          y: window.innerHeight / 2,
        },
        isTouchDevices: isMobile(),
        // // cursor1
        // color1: '#8c0fee',
        // color2: '#20FE5E',
        // tinyCursorFill: '#20FE5E',
      })
    }
  }

  componentWillUnmount(): void {
    this.cursor?.destory()
  }

  shouldComponentUpdate(): boolean {
    return false
  }

  render(): React.ReactNode {
    return <div className="bg-anime" ref={(r) => (this.ref = r)}></div>
  }
}
